import axios, { AxiosResponse } from 'axios';

export interface ISezZakEmisi {
    isin: string;
    typz: string;
}

export interface ISezZaknihovanychEmisi {
    listissue: ISezZakEmisi[];
}

const vlastneneEmiseApi = (idsbj: number) => {
    return axios({
        method: 'GET',
        url: window.location.origin + `/isbpublicjson/api/Issuer/${idsbj}?lang=cz`
    }).then((resp: AxiosResponse<ISezZaknihovanychEmisi>) => resp.data.listissue);
};

export default vlastneneEmiseApi;
